import * as React from "react";
import { IImageTileProps, ImageState } from ".";
import { CaptionDiv, ImageContainerDiv, ImageTileContainerDiv } from "./ImageTile.styles";

const ImageTile = ({
    ImageURL,
    OnClick,
    Selected,
    ID,
    Title,
}: IImageTileProps) => {
    const [state, setState] = React.useState<ImageState>("ShowAlternative");

    const handleClick = () => {
        OnClick(ID);
    };

    return (
        <ImageTileContainerDiv onClick={handleClick} Selected={Selected}>
            <ImageContainerDiv>
                <img
                    src={ImageURL}
                    alt={Title}
                    onError={() => setState("ShowAlternative")}
                    onLoad={() => setState("ShowImage")}
                    style={{ opacity: state === "ShowImage" ? 1 : 0 }}
                />
            </ImageContainerDiv>
            <CaptionDiv>
                {Title}
            </CaptionDiv>
        </ImageTileContainerDiv>
    );
};

export default ImageTile;
